"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyNotice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="privacy-notice" className="bg-background w-full px-4 pb-12 pt-8">
      <div ref={ref} className={`mx-auto max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <Separator className="mb-8" />
        <p className="text-muted-foreground text-center font-sans text-sm font-normal leading-relaxed">
          Your privacy and security are our highest priorities. All submitted information is strictly confidential, securely encrypted, and handled in full compliance with professional medical data protection standards.
        </p>
      </div>
    </section>;
}